import { site } from '@/mocks/gossip';

const columns: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: '栏目导航',
    links: [
      { label: '八卦速递图文合集', href: '#feed' },
      { label: '长图合集', href: '#changtu' },
      { label: '明星盘点特辑', href: '#pandian' },
      { label: '小报精选', href: '#xiaobao' },
      { label: '关于我们与订阅', href: '#about' },
    ],
  },
  {
    title: '看什么',
    links: [
      { label: '硬核深扒', href: '#feed' },
      { label: '红毯造型', href: '#feed' },
      { label: '幕后现场', href: '#feed' },
      { label: '八卦速报订阅', href: '#about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50">瓜</span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black text-foreground-950">{site.brand}</span>
                <span className="mt-1 text-[10px] tracking-[0.2em] text-primary-600">GUATIAN WEEKLY</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-700">
              {site.slogan}。我们专注把明星八卦合集、八卦长图、深扒与盘点整理成好读的图文内容，热门事件一网打尽，陪你轻松吃瓜。
            </p>
            <div className="mt-4 flex gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-reddit-line', 'ri-chat-heart-line'].map((ic) => (
                <a
                  key={ic}
                  href={`mailto:${site.email}`}
                  aria-label="编辑部联系方式"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((c) => (
            <nav key={c.title} aria-label={c.title}>
              <h4 className="mb-3 font-heading text-sm font-bold text-foreground-950">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-700 transition hover:text-primary-600">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="max-w-3xl text-[11px] leading-5 text-foreground-600">
            免责声明：本网站内容为编辑部基于公开素材的娱乐资讯整理与汇编，仅供参考与分享，不构成对任何具体个人的事实性判断或评价。若任何内容涉及权益争议，请联系
            <a href={`mailto:${site.email}`} className="font-medium text-primary-700"> {site.email} </a>
            以便更正或删除。
          </p>
          <div className="mt-4 flex flex-col items-start justify-between gap-2 text-[11px] text-foreground-500 sm:flex-row sm:items-center">
            <p>© {new Date().getFullYear()} {site.brand} · 把娱乐圈的瓜，炖成好读的汤</p>
            <a href="#top" className="inline-flex items-center gap-1 hover:text-primary-600">
              返回顶部
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}